import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL, ASSIGNMENT_GRID_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams, GridPostParams } from 'common/models/utility-models/list-utility.model';
import { environment } from 'src/environments/environment';
import { UsersGridParams, UsersListingModel, UsersModel } from 'common/models/page-models/users/users-grid-model';
import { GridDataService } from '../../base-data-services/grid-data.service';



@Injectable({
    providedIn: 'root'
})
export class UsersGridDataService extends GridDataService<UsersListingModel, UsersModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.getUsersList, http, ss);
        
    }

    createInstance(): UsersListingModel {
        return new UsersListingModel();
    }

    getDeleteUrl() {
        return environment.apiUrl+API_URL.deleteUsers;
    }

    override getGridParams(param): GridPostParams {
        return new UsersGridParams();
    }
}
